import { ShopperReservationMode } from '@iheartjane/types';
import { z } from 'zod';

export const IntentSchema = z.enum(['changeStore', 'initialPin']);

// See also ShoppingPreferencesSchema
export const PinStorePayloadSchema = z.object({
  city: z.string().nullish(),
  countryCode: z.string().nullish(),
  intent: z.literal(IntentSchema.enum.changeStore),
  lat: z.coerce.number().nullish(),
  long: z.coerce.number().nullish(),
  redirectTo: z.string().optional(),
  reservationMode: z.enum(ShopperReservationMode).default('pickup'),
  state: z.string().nullish(),
  storeId: z.coerce.number().nullish(),
  streetAddress: z.string().nullish(),
  streetAddress2: z.string().nullish(),
  userEnteredAddress: z.string().nullish(),
  zipcode: z.string().nullish(),
});

export type PinStorePayload = z.infer<typeof PinStorePayloadSchema>;

export const PinInitialStorePayloadSchema = z.object({
  intent: z.literal(IntentSchema.enum.initialPin),
  lat: z.coerce.number(),
  long: z.coerce.number(),
  storeId: z.coerce.number().nullish(),
});

export type PinInitialStorePayload = z.infer<
  typeof PinInitialStorePayloadSchema
>;
